import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from "../services/auth.service";
import { activityLogService } from 'src/app/services/activityLog.service';
import { ActivityLogs } from '../models/activity-logs';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private auth: AuthService, private router: Router, private activityLog: activityLogService) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    let activity: ActivityLogs = {
      action: 'View',
      entity: 'User',
      module: state.url,
      sub_module: state.url,
    };
    this.activityLog.store(activity);
        
    if (this.auth.isAuthenticated()) {
      //this.router.navigate(['/']); //Descomentar para mantenimiento
      return true; //Descomentar para produccion
      //return false; //Descomentar para mantenimiento
    } else {
      this.router.navigate(['/']);
      return false;
    }
  }
}
